import {
  IInputDataRequiredState,
  showInputDataRequiredDialog,
} from 'src/brm/actions/input-data-required/input-data-required';
import { DataInputs, IBRMInputDataRequiredInput } from 'src/common/api/brm/brm-utils';
import { popEmeraldModal } from 'src/common/emerald-modal-manager/emerald-modal-manager';
import { IOwnBagConfigurationMethodType } from 'src/common/interfaces/dtos/ITouchPointConfiguration';
import { IItemInputData } from 'src/common/interfaces/IItemInputData';
import { store } from 'src/common/redux/configure-store';
import { popupMessage } from 'src/messages/business-logic/popup-message';
import { updateLineItemQuantity, OWN_BAG_MODAL_ID } from './handle-update-quantity';

interface IProps {
  onAccept: () => void;
  onCancel: () => void;
}

export const showOwnBagPolicyDialog = (props: IProps) => {
  const ownBagConfiguration = store.getState().touchPoint?.touchPointConfiguration
    ?.ownBagConfiguration;
  const productId = ownBagConfiguration?.productId;

  const modalProps: IInputDataRequiredState = {
    type: DataInputs.Numeric,
    captionKey: 'OwnBagDialogCaption',
    messageKey: 'OwnBagDialogMessage',
    onCancel: () => {
      popEmeraldModal();
      props.onCancel();
    },
    onAccept: async (data: string | IBRMInputDataRequiredInput): Promise<void> => {
      const inputData: IItemInputData = {
        quantity: data['value'] ? parseInt(data['value']) : 0,
        itemId: productId,
      };

      try {
        await updateLineItemQuantity(inputData);
        popEmeraldModal(OWN_BAG_MODAL_ID);
        props.onAccept();
      } catch (e) {
        popupMessage(e);
      }
    },
    fullScreen: false,
    titleKey: 'OwnBagTitle',
    isAllowPrecision: false,
  };

  showInputDataRequiredDialog(modalProps, OWN_BAG_MODAL_ID);
};

export const isShowOwnBagPolicyOnPayment = (): boolean => {
  const ownBagConfiguration = store.getState().touchPoint?.touchPointConfiguration
    ?.ownBagConfiguration;

  const isTriggeredOnPayment =
    ownBagConfiguration?.methodOfWork === IOwnBagConfigurationMethodType.TriggeredOnPayment;
  const productId = ownBagConfiguration?.productId;

  const items = store.getState().itemList.ejItems.filter(i => i.ItemId === productId);

  if (store.getState().tendering.isOwnBagDisabled) {
    return false;
  }

  return isTriggeredOnPayment && !items.length;
};
